import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var _require = require('lodash'),
    get = _require.get;

var Feedback = /*#__PURE__*/function () {
  function Feedback(feedback) {
    this._total = get(feedback, 'total', null);
    this._benchmark = get(feedback, 'benchmark', null);
    this._goodCatch = get(feedback, 'goodCatch', null);
    this._notInteresting = get(feedback, 'notInteresting', null);
    this._topGoodCatchMeasure = get(feedback, 'topGoodCatchMeasure', {});
    this._topNotInterestingMeasure = get(feedback, 'topNotInterestingMeasure', {});
  }

  Feedback.getPercentageDistribution = function getPercentageDistribution(a, b) {
    if (isNaN(a) || isNaN(b)) {
      return undefined;
    }

    var total = a + b;
    return {
      a: Math.round(a / total * 100) || 0,
      b: Math.round(b / total * 100) || 0
    };
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */
  ;

  _createClass(Feedback, [{
    key: 'total',
    get: function get() {
      return this._total;
    }
  }, {
    key: 'benchmark',
    get: function get() {
      return this._benchmark;
    }
  }, {
    key: 'topGoodCatchMeasure',
    get: function get() {
      return Object.keys(this._topGoodCatchMeasure).join('');
    }
  }, {
    key: 'topNotInterestingMeasure',
    get: function get() {
      return Object.keys(this._topNotInterestingMeasure).join('');
    }
  }, {
    key: 'feedbackPercentageDistribution',
    get: function get() {
      return Feedback.getPercentageDistribution(this._goodCatch, this._notInteresting);
    }
  }]);

  return Feedback;
}();

export { Feedback as default };